export enum FeatureFlags {
  NewOffersUIEnabled = 'new-offers-ui-enabled',
  NewOffersUIMsftEnabled = 'new-offers-ui-msft-enabled',
  NewOffersUIMsftFlexibleBillingEnabled = 'new-offers-ui-msft-flexible-billing-enabled',
  NewOffersUIGcpEnabled = 'new-offers-ui-gcp-enabled',
}
